import _regeneratorRuntime from "C:\\Executables\\Raindeers\\ClaimsHub\\frontend\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/regenerator";
import { getConfigValue } from '@jutro/config';
import { warning, info } from '@jutro/logger';
import { fetchTsmMessages } from './fetchTsmMessages';
export var tsmMessageLoader = function tsmMessageLoader(language) {
  var worksetUid, stringVersion, stringGroup, jutroVersion;
  return _regeneratorRuntime.async(function tsmMessageLoader$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          worksetUid = getConfigValue('JUTRO_TSM_WORKSET_UID', 'active');
          stringVersion = getConfigValue('JUTRO_TSM_STRING_VERSION');
          stringGroup = getConfigValue('JUTRO_TSM_STRING_GROUP');
          jutroVersion = getConfigValue('JUTRO_CORE_STRING_VERSION');
          info("TSM enabled: Loading messages for \"".concat(language, "\" language, worksetUid: \"").concat(worksetUid, "\", string group: \"").concat(stringGroup, ":."));
          _context.prev = 5;
          _context.next = 8;
          return _regeneratorRuntime.awrap(fetchTsmMessages(language, worksetUid, stringGroup, undefined, stringVersion, jutroVersion));

        case 8:
          return _context.abrupt("return", _context.sent);

        case 11:
          _context.prev = 11;
          _context.t0 = _context["catch"](5);
          warning("TSM: Error loading translations. Details: ".concat(_context.t0));
          return _context.abrupt("return", {});

        case 15:
        case "end":
          return _context.stop();
      }
    }
  }, null, null, [[5, 11]], Promise);
};